import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { OrganisationRoutes } from '@organisations/organisation.routes';
import { PageTitleComponent } from '@shared/components/sections/page-title/page-title.component';
import { StepNavigatorComponent } from '@shared/components/ui/step-navigator/step-navigator.component';
import { IStepNavigatorConfig, StepDisplay, StepModes, StepUI } from '@shared/models/step-navigator';

@Component({
	selector: 'app-organisation',
	imports: [CommonModule, PageTitleComponent, RouterOutlet, StepNavigatorComponent],
	templateUrl: './organisation.component.html',
	styleUrl: './organisation.component.scss',
})
export class OrganisationComponent {
	stepConfig: IStepNavigatorConfig = {
		ui: StepUI.WIZARD,
		mode: StepModes.ROUTER_OUTLET,
		displayType: StepDisplay.AUTO,
		showStepChevrons: false,
		showStepNumbers: false,
		showNavButtons: true,
		steps: [
			{
				title: {
					full: 'Company Details',
					tabs: 'Details',
				},
				icon: 'bi-briefcase',
				route: [OrganisationRoutes.DETAILS],
				disabled: false,
			},
			{
				title: {
					full: 'Users',
					tabs: 'Users',
				},
				icon: 'bi-person-add',
				route: [OrganisationRoutes.USERS],
				disabled: false,
			},
			{
				title: {
					full: 'Billing',
					tabs: 'Billing',
				},
				icon: 'bi-receipt',
				route: [OrganisationRoutes.BILLING],
				disabled: false,
			},
		],
	};
}
